import {$$} from '@vue-macros/reactivity-transform/macros'

import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'

import {
  IMailPropertyTypeInterfaces,
} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/MailPropertyTypeStrategy/types/IMailPropertyTypeInterfaces'
import {PropertyStrategyComponentType} from '@toolify/client/src/modules/tableItems/enum/PropertyStrategyComponentType'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterGroupOperator} from '@toolify/server/src/services/FilterService/enum/FilterGroupOperator'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'

export function useMailValueTypeStrategy() {
  const strategyComponentType = PropertyStrategyComponentType.Input

  const fullValueToText = (value: IMailPropertyTypeInterfaces['fullValue'], property: IDatabasePropertyResponseInstance) => {
    return String(value || '')
  }

  const searchToFilterQuery = (search: string, databaseProperties: IDatabasePropertyResponseInstance[]): IFilter => {
    return {
      type: FilterItemType.Group,
      operator: FilterGroupOperator.Or,
      items: databaseProperties.map(databaseProperty => {
        return {
          type: FilterItemType.Property,
          id: databaseProperty.id,
          subProperty: null,
          operator: {
            type: FilterPropertyOperator.RegExp,
          },
          payload: {
            type: FilterPropertyPayloadType.Static,
            value: search,
          },
          isDisabled: false,
        }
      }),
    }
  }

  const compareItemValues = (
    valueA: IMailPropertyTypeInterfaces['fullValue'],
    valueB: IMailPropertyTypeInterfaces['fullValue'],
    sortDirection: '1' | '-1',
  ): number => {
    const hasValueA = valueA !== null && valueA !== undefined && valueA !== ''
    const hasValueB = valueB !== null && valueB !== undefined && valueB !== ''
    
    if (!hasValueA && !hasValueB) return 0
    if (!hasValueA) return 1
    if (!hasValueB) return -1
    
    const strA = String(valueA || '')
    const strB = String(valueB || '')
    const comparison = strA.localeCompare(strB)
    
    return sortDirection === '1' ? comparison : -comparison
  }

  return $$({
    fullValueToText,
    strategyComponentType,
    searchToFilterQuery,
    compareItemValues,
  })
}
